import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { ScrollToTopButton } from './ScrollToTopButton';
import { SiteFooter } from './SiteFooter';
import { PWAInstallPrompt } from './PWAInstallPrompt';
import { CookieConsent } from './CookieConsent';
import { useLanguage } from '../contexts/LanguageContext';
import { MenuConfigProvider } from '../contexts/MenuConfigContext';

function PublicSiteWrapper() {
  const { lang, isRTL } = useLanguage();
  const isAr = lang === 'ar';
  return (
    <div
      className="public-site min-h-screen flex flex-col font-sans selection:bg-terracotta/30"
      lang={lang}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:start-3 focus:z-[200] focus:bg-sea-blue focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-cyan-400"
      >
        {isAr ? 'تخطى إلى المحتوى' : 'Skip to content'}
      </a>
      <TopNav />
      <div className="h-20 md:h-24 shrink-0" aria-hidden="true" />
      <div id="main-content" tabIndex={-1} className="contents">
        <Outlet />
      </div>
      <SiteFooter />
      <PWAInstallPrompt />
      <CookieConsent />
      <ScrollToTopButton />
    </div>
  );
}

export function PublicLayout() {
  return (
    <MenuConfigProvider>
      <PublicSiteWrapper />
    </MenuConfigProvider>
  );
}
